module.exports = __webpack_public_path__ + "static/media/trailz.1b87535d.png";